import { useMemo } from "react";
import { Observable } from "utils";

export function useObservable<T extends (...args: any[]) => void>() {
  return useMemo(() => new Observable<T>(), []);
}
